export default __webpack_public_path__ + "static/media/SignInBg.e1f48118.png";